import NewsSlider from './newsSlider';

export default NewsSlider;
